import { createContext, useContext, type PropsWithChildren } from "react";
import type { SmsConfigurationApi } from "../data/SmsConfigurationApi";
const Context=createContext<SmsConfigurationApi|null>(null);
export const SmsConfigurationProvider=({api,children}:PropsWithChildren<{api:SmsConfigurationApi}>)=><Context.Provider value={api}>{children}</Context.Provider>;
export const useSmsConfigurationApi=()=>{const api=useContext(Context);if(!api)throw new Error("SmsConfigurationProvider required");return api;};
